import PageProductDetail from '~/themes/soh/components/product/PageProductDetail'

export default {
  mixins: [PageProductDetail],
}
